import ApiService from '../../../../shared/services/api-service';
import commonActionsCreators from '../../../../shared/store/common/action-creators';
import departmentActionsCreators from '../../department/action-creators';
import reportsCommitTypes from '../commit-types';
import notificationsActionsCreator from '../../notifications/action-creators';
import trainingPhasesActionsCreators from '../../training-phases/action-creators/training-phases';

const reportsActionCreators = {
  addReport() {
    return {
      isAddingReport: true,
      type: reportsCommitTypes.SET_IS_ADDING_REPORT,
    };
  },
  closeAddReport() {
    return {
      isAddingReport: false,
      type: reportsCommitTypes.SET_IS_ADDING_REPORT,
    };
  },
  createReport(formData) {
    return async (dispatch) => {
      dispatch(this.setIsLoading('createReport'));
      const data = await ApiService.post('/api/v1/reports', formData)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionsCreators.handleApiError(error));
          return Promise.resolve();
        });
      dispatch(this.setIsLoading('createReport'));
      if (data) {
        dispatch(this.createReportSuccess(data));
      }
      return Promise.resolve(data.data.guid);
    };
  },
  createReportSuccess(created) {
    return (dispatch) => {
      dispatch(this.pushReport(created.data));
      dispatch(this.setIsAddingReport(false));
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Report created'));
    };
  },
  editReport(isEditingReport) {
    return {
      isEditingReport,
      type: reportsCommitTypes.SET_IS_EDITING_REPORT,
    };
  },
  fetchReports(scope) {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchReports'));
      const getFetchReportsUrl = () => {
        switch (scope) {
          case 'fto':
          case 'oit':
            return '/api/v1/my-reports';
          default:
            return '/api/v1/reports';
        }
      };
      const data = await ApiService.get(getFetchReportsUrl())
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('fetchReports'));
      if (data.error) {
        dispatch(commonActionsCreators.handleApiError(data.error));
      } else {
        dispatch(this.fetchReportsSuccess(data, scope));
      }
    };
  },

  fetchOpenReports(scope) {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchReports'));
      const getFetchReportsUrl = () => {
        switch (scope) {
          case 'fto':
          case 'oit':
            return '/api/v1/my-reports';
          default:
            return '/api/v1/reports/pending';
        }
      };
      const data = await ApiService.get(getFetchReportsUrl())
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('fetchReports'));
      if (data.error) {
        dispatch(commonActionsCreators.handleApiError(data.error));
      } else {
        dispatch(this.fetchOpenReportsSuccess(data, scope));
      }
    };
  },

  fetchReportsForFtoApprove() {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchReports'));

      const data = await ApiService.get('/api/v1/reports')
        .then(response => response.data)
        .catch(error => ({error}));

      const myData = await ApiService.get('/api/v1/my-reports')
        .then(response => response.data)
        .catch(error => ({ error }));

      dispatch(this.setIsLoading('fetchReports'));
      if (data.error) {
        dispatch(commonActionsCreators.handleApiError(data.error));
      } else {
        let list = data.data.filter(report => {
          return report.attributes.author &&
            (
              (report.attributes.signFlow[report.type].approve_one
                && report.attributes.signFlow[report.type].approve_one.required
                && report.attributes.signFlow[report.type].approve_one.roles.includes('fto'))
              || (report.attributes.signFlow[report.type].approve_two
                && report.attributes.signFlow[report.type].approve_two.required
                && report.attributes.signFlow[report.type].approve_two.roles.includes('fto'))
              || (report.attributes.signFlow[report.type].approve_three
                && report.attributes.signFlow[report.type].approve_three.required
                && report.attributes.signFlow[report.type].approve_three.roles.includes('fto'))
              || (report.attributes.signFlow[report.type].approve_four
                && report.attributes.signFlow[report.type].approve_four.required
                && report.attributes.signFlow[report.type].approve_four.roles.includes('fto'))
              || (report.attributes.signFlow[report.type].approve_five
                && report.attributes.signFlow[report.type].approve_five.required
                && report.attributes.signFlow[report.type].approve_five.roles.includes('fto'))
            )
        })
        let finalList = [...list, ...myData.data];
        let finalListMap = finalList.reduce((acc, rep) => ({
          ...acc,
          [rep.guid]: rep
        }), {})

        finalList = finalList.map(rep => rep.guid).filter((item, pos, self) => {
          return self.indexOf(item) === pos;
        })

        dispatch({
          list: finalList.map(id => finalListMap[id]),
          type: reportsCommitTypes.PUSH_REPORTS,
        });
      }
    };
  },

  fetchReportsSuccess(reportsResponse, scope) {
    return (dispatch) => {
      dispatch(this.pushReports(reportsResponse.data, scope));
    };
  },
  fetchOpenReportsSuccess(reportsResponse, scope) {
    return (dispatch) => {
      dispatch(this.pushOpenReports(reportsResponse.data, scope));
    };
  },
  sendReminder(formData) {
    return async (dispatch) => {
      dispatch(this.setIsLoading('sendReminder'));
      const postData = { ...formData };
      // Remove redundant
      delete postData.guid;
      const data = await ApiService.post(
        `/api/v1/reports/${formData.guid}/reminder`,
        postData,
      )
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionsCreators.handleApiError(error));
          return Promise.resolve();
        });
      dispatch(this.setIsLoading('sendReminder'));
      if (data) {
        dispatch(this.sendReminderSuccess(data));
      }
      return Promise.resolve();
    };
  },
  sendReminderSuccess(updated) {
    return (dispatch) => {
      dispatch(this.replaceReport(updated.data));
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Reminder sent'));
    };
  },
  loadReportContainer(scope) {
    return (dispatch) => {
      dispatch(this.fetchOpenReports(scope));
      dispatch(departmentActionsCreators.fetchDepartmentForms());
    };
  },
  pushReport(report) {
    return {
      report,
      type: reportsCommitTypes.PUSH_REPORT,
    };
  },
  replaceReport(report) {
    return {
      report,
      type: reportsCommitTypes.REPLACE_REPORT,
    };
  },
  pushReports(list) {
    return {
      list,
      type: reportsCommitTypes.PUSH_REPORTS,
    };
  },
  pushOpenReports(list) {
    return {
      list,
      type: reportsCommitTypes.PUSH_OPEN_REPORTS,
    };
  },
  resetReportState() {
    return {
      type: reportsCommitTypes.RESET_REPORTS_STATE,
    };
  },
  setIsAddingReport(isAddingReport) {
    return {
      isAddingReport,
      type: reportsCommitTypes.SET_IS_ADDING_REPORT,
    };
  },
  setIsViewingReport(viewingReport) {
    return {
      viewingReport,
      type: reportsCommitTypes.SET_IS_VIEWING_REPORT,
    };
  },
  setIsLoading(isLoading) {
    return {
      isLoading,
      type: reportsCommitTypes.SET_REPORTS_IS_LOADING,
    };
  },
  removeReport(report) {
    return {
      reportGuid: report.guid,
      type: reportsCommitTypes.REMOVE_REPORT,
    };
  },
  unmountReportContainer() {
    return (dispatch) => {
      dispatch(this.resetReportState());
    };
  },
  removeScheduledReport(reportGuid) {
    return async (dispatch) => {
      dispatch(trainingPhasesActionsCreators.setIsLoading('deleteScheduledReport'));
      const data = await ApiService.delete(`/api/v1/scheduled-reports/${reportGuid}`)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.resolve();
        });
      dispatch(trainingPhasesActionsCreators.setIsLoading('deleteScheduledReport'));
      if (data) {
        dispatch(this.deleteScheduledReportSuccess(data));
      }
      return Promise.resolve();
    };
  },
  removeDraftReport(reportGuid) {
    return async (dispatch) => {
      dispatch(trainingPhasesActionsCreators.setIsLoading('deleteDraftReport'));
      const data = await ApiService.delete(`/api/v1/reports/${reportGuid}`)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.resolve();
        });
      dispatch(trainingPhasesActionsCreators.setIsLoading('deleteDraftReport'));
      if (data) {
        dispatch(this.deleteDraftReportSuccess(data));
      }
      return Promise.resolve();
    };
  },
  deleteDraftReportSuccess(deleted) {
    return (dispatch) => {
      dispatch(this.removeReport(deleted.data));
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Draft deleted'));
    };
  },

  deleteScheduledReportSuccess(deleted) {
    return (dispatch) => {
      dispatch(this.removeReport(deleted.data));
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Scheduled 1 reports deleted'))
    };
  },
};

export default reportsActionCreators;
